import React from 'react'
import styled from 'styled-components'

export function Banner() {
    return (
        <BannerRoot
            href="https://snapshot.org/#/streamr.eth/proposal/0x9888d408eb02c9bcdd2cf47e8b4f717306bb12dac1b21f692c2d68b2eb87b306"
            rel="noopener noreferrer"
            target="_blank"
        >
            <div>
                <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                    <g fill="none" fillRule="evenodd" transform="matrix(1 0 0 -1 0 16)">
                        <circle cx="8" cy="8" r="8" fill="#525252" />
                        <path
                            stroke="#FFF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M8 11.5v.1m0-2.8V4"
                        />
                    </g>
                </svg>
            </div>
            <div>
                SIP-22 is now live for voting on Snapshot until <em>28th&nbsp;October</em>
            </div>
        </BannerRoot>
    )
}

const BannerRoot = styled.a`
    align-items: center;
    justify-content: center;
    display: flex;
    gap: 12px;
    min-height: 40px;
    padding: 12px 24px;
    box-sizing: border-box;
    background: #323232;
    color: #ffffff !important;
    text-decoration: none !important;
    font-size: 14px;

    svg {
        display: block;
    }

    em {
        font-style: normal;
        font-weight: 500;
    }
`
